import { serverFetch } from "@core/server";

export function fetchSprTemplateNaznList() {
  return serverFetch("template");
}

export function fetchSprTemplateNaznItems(idShb) {
  return serverFetch(`template/listcnt/${idShb}`);
}

export function createSprTemplateNazn(bodyData) {
  return serverFetch("template", {
    method: "POST",
    bodyData
  });
}

export function saveSprTemplateNazn(idShb, bodyData) {
  return serverFetch(`template/${idShb}`, {
    method: "PUT",
    bodyData
  });
}

export function deleteSprTemplateNazn(idShb) {
  return serverFetch(`template/${idShb}`, {
    method: "DELETE"
  });
}

export function createSprTemplateNaznItem(idShb, bodyData) {
  return serverFetch(`template/${idShb}/items`, {
    method: "POST",
    bodyData
  });
}

export function saveSprTemplateNaznItem(idShb, idStr, bodyData) {
  return serverFetch(`template/${idShb}/items/${idStr}`, {
    method: "PUT",
    bodyData
  });
}

export function deleteSprTemplateNaznItem(idShb, idStr) {
  return serverFetch(`template/${idShb}/items/${idStr}`, {
    method: "DELETE"
  });
}

export function fetchSprTemplateNaznParamNames(idUsl) {
  return serverFetch(`template/param-names/${idUsl}`);
}

export function fetchSprTemplateNaznParamValues(idUsl, name) {
  return serverFetch(`template/param-values/${idUsl}`, {
    queryParams: { name }
  });
}
